import styled, { keyframes } from 'styled-components'

export const Float = keyframes`
  0% {
		transform: translatey(0px);
	}
	50% {
		transform: translatey(-20px);
	}
	100% {
		transform: translatey(0px);
	}
`

export const CardContainer = styled.div`
  padding: 5px;
  height: 60%;
  margin-left: 30px;

  p {
    font-family: 'Noto Sans Thai';
    font-size: clamp(20px, 2.5vw, 24px);
    text-align: center;
    line-height: 40px;
    margin-top: 28px;
    min-height: 100px;
  }

  @media screen and (max-width: 820px) {
    margin-left: 0;
    height: auto;
  }

  .icon-learn {
    overflow: hidden;
    transform: translatey(0px);
    animation: ${Float} 6s ease-in-out infinite;
  }
`
